module.exports = __webpack_public_path__ + "media/images/112x112_shadow-6836c45100fed0884bd34bb3548e3c693b0eebc473d60cf2b5d4ef24d3ab18e3.png";